import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
const painPoints = [{
  title: 'Llegás sin saber qué dar',
  desc: 'Sin saber qué secuencia o actividad vas a trabajar esa semana.'
}, {
  title: 'Contenidos que no progresan',
  desc: 'Sin estructura clara para que el alumno pase de un nivel al siguiente.'
}, {
  title: 'Los alumnos no comprenden',
  desc: 'Explicás y explicás pero la mayoría no llega al concepto esperado.'
}, {
  title: 'Siempre las mismas actividades',
  desc: 'No sabés cómo diseñar situaciones didácticas que realmente funcionen.'
}, {
  title: 'El CFE como una amenaza',
  desc: 'Querés alinearte a los NAP pero no sabés cómo hacerlo en la práctica.'
}, {
  title: 'Tips sueltos de Pinterest',
  desc: 'Sin un método claro que respalde tu planificación pedagógica.'
}, {
  title: 'No sabés cómo evaluar',
  desc: 'Tomás un examen pero no tenés criterios claros ni rúbricas.'
}, {
  title: 'Fin de trimestre sin resultados',
  desc: 'Sin secuencia progresiva, los alumnos no avanzan y vos te agotás.'
}];
export const PainPoints = () => {
  return <section className="py-20 bg-cream" data-id="element-207">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-210">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-211">
            Si enseñás matemática en primaria en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-212">
          {painPoints.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex gap-4 bg-white p-6 rounded-xl shadow-sm border border-red-100" data-id="element-213">
              <div className="flex-shrink-0 mt-1" data-id="element-214">
                <AlertCircle className="text-red-400" size={24} data-id="element-215" />
              </div>
              <div data-id="element-216">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-217">{pain.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-218">
                  {pain.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-219">
          <p className="text-2xl md:text-3xl font-heading font-bold text-brand-orange" data-id="element-220">
            ¿Cuántos trimestres más vas a planificar improvisando?
          </p>
        </motion.div>
      </div>
    </section>;
};